module.exports = __webpack_public_path__ + "media/control_acceso/cortina-d75fb3d5.png";